module.exports = __webpack_public_path__ + "svg/icon-leaf-1-bg.svg";